import { jsx as _jsx } from "react/jsx-runtime";
import { useFetch } from '@rad/hooks';
import Skeleton from '@rad/components/utility/skeleton';
import { getConst } from '@rad/utility/http';
import { getCommunity } from '../../../../common/network/district';
import { useCommunity } from '../../../../hooks/useDistrict';
import { coreFromSettings, defaultColors } from '../../../../theme/config';
import { tourThemeOf } from '../../../../theme/tour';
import TourWizard from './tour-wizard';
// A tour that has not chosen a theme shows in its community's colors, so that is where the wizard
// starts it. Staff creating a tour on the root host have no community yet, so theirs starts in the
// default theme.
const TourWizardSeeded = (props) => {
    const { district } = useCommunity();
    const saved = props.tour === null ? null : tourThemeOf(props.tour.themeSettings);
    const subdomain = props.tour !== null ? props.tour.communitySubdomain : props.crossCommunity ? '' : district.subdomain;
    const [communityPromise] = useFetch(subdomain === '' ? getConst(null) : getCommunity(subdomain));
    return (_jsx(Skeleton, { promise: communityPromise, children: community => {
            var _a;
            const communityColors = community === null ? null : coreFromSettings(community.themeSettings);
            return (_jsx(TourWizard, { tour: props.tour, crossCommunity: props.crossCommunity, theme: (_a = saved !== null && saved !== void 0 ? saved : communityColors) !== null && _a !== void 0 ? _a : defaultColors, communityColors: communityColors }));
        } }));
};
export default TourWizardSeeded;
